/**
 * The browser entry point.
 *
 * There is no server entry any more (decision F-D4): this app is static files plus the API, so
 * the only things left to do at startup are restoring the sign-in session and mounting the router
 * into `#root`. `src/server.ts`,
 * `src/start.ts` and `src/lib/error-capture.ts` -- the SSR error-unwrapping machinery that
 * existed because h3 swallowed in-handler throws into a JSON 500 -- went with it. Errors are
 * handled where they are seen: `__root.tsx`'s `errorComponent` for a render failure, and each
 * query's own error state for a request failure.
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";

import { startSession } from "./api/session";
import { getRouter } from "./router";
import "./styles.css";

const router = getRouter();

const container = document.getElementById("root");
if (!container) throw new Error("index.html is missing #root");

// The session is restored before the first render (AU-D13): MSAL has to be initialised from the
// sign-in option kept in `sessionStorage` before it can say who is signed in, and a gate that
// rendered first would send a signed-in person to `/login` for a frame. `startSession` never
// rejects; a session it cannot restore is simply a signed-out one.
void startSession().then(() => {
  createRoot(container).render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  );
});
